import React from 'react';
import PropTypes from 'prop-types';
import { StatusTag } from 'web-ui-components/lib/typography/tags';

const getBadge = (status) =>
  ({
    Authorised: StatusTag.NotStarted,
    Paid: StatusTag.Success,
    Processing: StatusTag.Ongoing,
    Pending: StatusTag.WarningMinor,
    Failed: StatusTag.ErrorMajor,
    Submitted: StatusTag.Success,
    'Pending Submission': StatusTag.NotStarted,
    Declined: StatusTag.ErrorMinor,
    Cancelled: StatusTag.ErrorMinor,
    'Partially successful': StatusTag.WarningMajor,
    Suspended: StatusTag.NotStarted,
  }[status]);

const StatusBadgeSME = ({ status }) => {
  const component = getBadge(status);
  return component ? React.createElement(component, null, `${status}`) : null;
};

StatusBadgeSME.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusBadgeSME;
